import React, { ReactText } from 'react';

import t from '../../../labels/labelling-utils';
import { makeClassNames } from '../../../utils/styles';
import IconStar from '../../atoms/icons/icon-star';
import Text from '../../atoms/text/text';
import Tooltip from '../../atoms/tooltip/tooltip';

import './report-player.scss';

export interface IReportPlayer {
  fullname?: string | null; // Just like IReferee interface in src/typings/player.ts
  topPlayer?: boolean;
  vote?: ReactText;
  isAway?: boolean;
  playerPageLink?: string;
}

const classNames = (isAway: boolean | undefined, playerPageLink: boolean | undefined) =>
  makeClassNames({
    reportPlayer: 'report-player',
    name: ['report-player__name', playerPageLink && 'report-player__name--link'],
    vote: ['report-player__vote', isAway && 'report-player__vote--away'],
  });

const ReportPlayer = ({
  /* istanbul ignore next: default value */ topPlayer = false,
  /* istanbul ignore next: default value */ fullname = '',
  isAway,
  vote,
  playerPageLink,
}: IReportPlayer) => {
  const cn = classNames(isAway, Boolean(playerPageLink));

  return (
    <div className={cn.reportPlayer}>
      <Text
        className={cn.name}
        href={playerPageLink}
        color="blue"
        fontWeight="500"
        fontSize="14"
        tag={playerPageLink ? 'a' : 'span'}
      >
        {fullname}
        {topPlayer && (
          <Tooltip text={t('report.top.player')}>
            <IconStar size="xxsmall" color="red-lighter" />
          </Tooltip>
        )}
      </Text>
      <span className={cn.vote}>{vote}</span>
    </div>
  );
};

export default ReportPlayer;
